import React from "react";
const Tooltip = () => {
  return (
    <>
      <ul>
        <li>
          {" "}
          In case the net weight of the actual product is less than the
          mentioned weight, a partial refund shall be initiated.
        </li>
        <li>
          In case the net weight of the actual product is higher than the
          mentioned weight, we shall ask for the extra amount by sending a
          payment link.
        </li>
        <li>
          The final invoice amount shall be adjusted in case there is any
          variation in net weight.
        </li>
      </ul>
    </>
  );
};

export default Tooltip;
